import { AuthSurface } from 'components/ui';
import { getZoomAdjustedCssValue, getZoomAdjustedPx } from 'components/ui/utilities/zoom';
import { useZoom } from 'context/ZoomContext';
import { AuthFooterLinks } from 'pages/Auth/components';
import { AuthLayoutProps } from './AuthLayout.props';
import { AuthLayoutContent, AuthLayoutFormSlot, AuthLayoutRoot } from './AuthLayout.styles';

const AuthLayout = ({ children }: AuthLayoutProps) => {
  const { zoomLevel } = useZoom();

  return (
    <AuthLayoutRoot
      sx={{
        minHeight: getZoomAdjustedCssValue('100vh', zoomLevel),
        '@supports (min-height: 100dvh)': {
          minHeight: getZoomAdjustedCssValue('100dvh', zoomLevel),
        },
      }}
    >
      <AuthLayoutContent>
        <AuthLayoutFormSlot>
          <AuthSurface
            sx={{
              maxWidth: getZoomAdjustedPx(460, zoomLevel),
            }}
          >
            {children}
          </AuthSurface>
        </AuthLayoutFormSlot>
        <AuthFooterLinks />
      </AuthLayoutContent>
    </AuthLayoutRoot>
  );
};

export default AuthLayout;
